import { useEffect } from 'react';

import reminder from '../../assets/reminder.mp3';

export const playReminder = () => {
  const alertAudio = new Audio(reminder);
  alertAudio.play();
};

type Props = {
  onPlay?: () => void;
};

export function ReminderSound({ onPlay }: Props): React.ReactNode {
  useEffect(() => {
    playReminder();
    onPlay?.();
  }, [onPlay]);

  return null;
}
